import { gql, type OperationVariables } from '@apollo/client';

import GraphQL from '../graphQL';

const query = gql`
mutation updateMyWebsiteUrl($websiteUrl: String) {
    updateMyWebsiteUrl(websiteUrl: $websiteUrl) 
},
`;

export default async function updateMyWebsiteUrl(websiteUrl?: string) {
    const variables: OperationVariables = {
        websiteUrl: websiteUrl || null,
    };
    return GraphQL.mutate<boolean>(query, variables);
}
